import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
* {
    outline: 0;
    box-sizing: border-box;
  }

	html {
		font-family: "Montserrat", -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,
		"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol", SFMono-Regular,Menlo,Monaco,Consolas,
		"Liberation Mono","Courier New",monospace;
	}

	button[data-tooltip="Soporte"] {
		display: none;
	}

	body {
		-webkit-font-smoothing: antialiased;

		background-color: var(--background);

		color: var(--color);

		overflow: hidden;
	}

	ul, ol {
    padding: 0 1rem;
  }

	ul {
		list-style: disc;
	}

	ol {
		list-style: decimal;
	}

	a { text-decoration: none; }

	@font-face {
		font-family: 'Montserrat';
		src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
	}

	@font-face {
		font-family: 'Montserrat';
		font-style: normal;
		font-weight: 400;
		src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
	}
	@font-face {
		font-family: 'Montserrat';
		font-style: normal;
		font-weight: 500;
		src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
	}
	@font-face {
		font-family: 'Montserrat';
		font-style: normal;
		font-weight: 600;
		src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
	}
	@font-face {
		font-family: 'Montserrat';
		font-style: normal;
		font-weight: 700;
		src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
	}
`;
